import GameModel from "../../../core/src/model/GameModel";
import { ICondition } from "../../../core/src/states/State";
import JackpotsModel from "../../model/JackpotsModel";

export default class HasJackpotsFeatureCondition implements ICondition {
    check() {
        return GameModel.gameConfig.hasJackpotsFeature && JackpotsModel.jackpotsAvailable;
    };
};
